
  import {Component, Vue, Watch} from "vue-property-decorator";
  import dayjs from "dayjs";
  import {
    getHistoryNum,
    getPrintGetHistoryDetail,
    getPackageList,
    getPrintNo
  } from "@/api/print";
  import {getOrgCodeListByPage} from "@/api/service";
  import {DestinationOrgcodename, ProgressBar} from "@/views/components";
  import YtoTable from "@/views/components/YtoTable/TtoTable.vue";
  import config from "./config";
  import Form2 from "./Form2.vue";
  import TableHeader from "./TableHeader.vue";
  import {date_day_add, parseTime} from "@/utils";
  import Enumerable from "linq";
  // import { logFunc } from '@/utils/prototype'
  // import {
  //   beforeMethod,
  //   afterMethod,
  //   onException,
  //   Metadata,
  //   MethodSignature
  // } from "kaop-ts";

  // const inlog = (meta: Metadata<any>) => {
  //   var a = meta;
  //   debugger;
  // };
  // const outlog = () => {
  // };
  @Component({
    name: "PackagePrintShape2",
    components: {
      DestinationOrgcodename,
      YtoTable,
      Form2,
      TableHeader,
      ProgressBar
    }
  })
  export default class extends Vue {
    @Watch("UnpackOrgName", {deep: false})
    oncurrentRowChanged(val: string) {
      if (val.length === 0) {
        this.inputModel.input_UnpackOrgName = "";
      }
    }

    @Watch("printCount", {deep: false, immediate: true})
    onPrintCountChanged() {
      this.printCountValue = this.printCount;
    }

    private rowEdit(row, idx) {
      row.edit = true;
      this.$nextTick(() => {
        var input: any = this.$refs["mark" + idx];
        if (input) {
          input.focus();
        }
      });

      this.$forceUpdate();
    }

    public loginData: LoginData; //系统登陆数据
    //打印进度条
    private progressBarDialogTitle = "";
    private proressBarDialogShow = false;
    private printCountValue = 0;
    private printCount = 0;
    private totalCount = 0;
    //-----
    private tabSelectIndex = "0";

    //查询打印数量
    private printCountDialogFormVisible = false;
    //-----
    //查询打印明细
    private printDetailDialogFormVisible = false;
    //-----
    private form = {};

    private inputModel: inputDataModel_PackagePrint = {
      input_PackageName: "",
      input_UnpackOrgName: "",
      input_PrinterName: "",
      input_PackageType: "",
      input_ProductType: "",
      input_LatticeNo:"",
      input_PaperSize: "",
    };
    public loading = false;
    public unpackageNameOptions = [];
    public input_DateRange = [];
    public timeOptionRange: String = "";
    public pickerOptions = {
      onPick: time => {
        if (time.minDate && !time.maxDate) {
          this.timeOptionRange = time.minDate;
        }
        if (time.maxDate) {
          this.timeOptionRange = null;
        }
      },
      disabledDate: time => {
        let timeOptionRange: any = this.timeOptionRange;
        let secondNum = 6 * 60 * 60 * 24 * 1000;
        if (timeOptionRange) {
          return (
            time.getTime() > timeOptionRange.getTime() + secondNum ||
            time.getTime() < timeOptionRange.getTime() - secondNum
          );
        }
      }
    };

    public pickerOptions2 = {
      onPick: time => {
        if (time.minDate && !time.maxDate) {
          this.timeOptionRange = time.minDate;
        }
        if (time.maxDate) {
          this.timeOptionRange = null;
        }
      }
    };
    public printCountForm = {
      dateRange: []
    };
    public printDetailForm = {
      packageName: "",
      dateRange: []
    };
    public table1Loading = false;

    get submitPrintDisable() {
      var c = Enumerable.from(this.printedResultShowList);
      var b = !c.any(f => f.ID && parseInt(f.countNum) > 0);
      console.log(`submitPrintDisable:${this.printedResultShowList.length}-${b}`);
      return b;
    }

    public remoteMethod(query) {
      if (query !== "") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          var body = {
            queryValue: query, //过滤字符串
            queryType: "19",
            viewType: "1",
            extend1: 1, //当前页
            extend2: 10, //页大小
            extend3: "" //过滤字段
          };
          var job = {
            devMac: "00-00-00-00-00-00",
            devType: "0",
            body: body
          };
          var requestJson = JSON.stringify(job);
          var orgs = getOrgCodeListByPage(requestJson);
          debugger;
          var orgsJson = JSON.parse(orgs);
          if (orgsJson.respcode === "000") {
            this.unpackageNameOptions = orgsJson.data.busiData.records.map(
              element => {
                return {value: element.code, label: element.name};
              }
            );
          } else {
            this.unpackageNameOptions = [];
          }
        }, 500);
      } else {
        this.unpackageNameOptions = [];
      }
    }

    mounted() {

      this.inputModel.input_PackageType = "QY";
      this.inputModel.input_ProductType = "普通";
      // try {
      //注册查询打印数据回传
      //   obj_PackagePrint.regist_SearchPrintDataCallback(
      //     this.SearchPrintDataCallback
      //   );
      //注册回传打印数量
      //   obj_PackagePrint.regist_PrintedCountCallback(this.PrintedCountCallback);
      // } catch (error) {
      // }

      this.GetAllPrinters(); //获取所有打印机
      //给两个查询框赋值
      var d1 = date_day_add(new Date(), -6);
      this.printDetailForm.dateRange[0] = d1 + " 00:00:00";
      this.printDetailForm.dateRange[1] = parseTime(
        new Date(),
        "{y}-{m}-{d} 00:00:00"
      );
      this.printCountForm.dateRange[0] = d1 + " 00:00:00";
      this.printCountForm.dateRange[1] = parseTime(
        new Date(),
        "{y}-{m}-{d} 00:00:00"
      );
      //-----

      var loginDataStr = obj_System_Core.getLoginData();
      this.loginData = JSON.parse(loginDataStr);
    }

    //打印完成后去除选中和后面的数字
    private ResetAfterPrinted() {
      (this.$refs.multipleTable as Vue & {
        clearSelection: Function;
      }).clearSelection();

      var newArray = this.printedResultShowList.map(function (item) {
        return {
          countNum: "",
          ID: item.ID,
          Name: item.Name,
          Type: item.Type,
          UnpackOrgName: item.UnpackOrgName,
          UnpackOrgCode: item.UnpackOrgCode,
          Count: item.Count,
          edit: false
        };
      });
      this.printedResultShowList = newArray;
    }

    //获取所有打印机
    // @logFunc('log装饰器')
    // @beforeMethod(inlog)
    // @afterMethod(outlog)
    private GetAllPrinters() {
      var printersStr = obj_Printer_Core.getAllPrinters();
      var printers = JSON.parse(printersStr);
      this.options = [];
      this.options = printers.map(item => {
        return {value: `${item}`, label: `${item}`};
      });
      if (this.options.length > 0) {
        this.inputModel.input_PrinterName = this.options[0].value;
      }
    }

    private isPrintIngFlag = false; //是否正在打印
    //提交打印，判断是否正在打印
    private SubmitPrintFunc() {
      debugger;
      if (!this.isPrintIngFlag) {
        try {
          this.isPrintIngFlag = true;
          this.submitPrint();
        } catch (error) {
          console.log("打印出错:" + error);
        } finally {
          this.isPrintIngFlag = false;
        }
      } else {
        this.$message.warning("有打印任务正在执行,请稍后");
      }
    }

    //构造打印数据
    public submitPrint() {
      var _requestModel = this.multipleSelection.map(item => {
        return {
          num: parseInt(item.countNum),
          printPersonCode: this.loginData.userCode,
          printPersonName: this.loginData.userName,
          productType: this.inputModel.input_ProductType,
          key: item.ID,
          packageName: item.Name,
          unBagOrgName: item.UnpackOrgName,
          unBagOrgCode: item.UnpackOrgCode,
          packageType: item.Type
        };
      });
      var responseData = getPrintNo(JSON.stringify(_requestModel));
      var responseDataJson = JSON.parse(responseData);
      if (responseDataJson.respcode === "000") {
        if (
          responseDataJson.data.listNos !== null &&
          responseDataJson.data.listNos.length > 0
        ) {
          this.proressBarDialogShow = true;
          this.printCount = 0;
          this.progressBarDialogTitle = "打印中";
          var totalCount = responseDataJson.data.listNos.length;
          this.totalCount = totalCount;
          setTimeout(() => {
            this.printStart(responseDataJson.data.listNos);
          }, 500);
        }
      } else {
        this.$message.error(responseDataJson.respMessage);
      }
    }

    //开始打印
    private async printStart(list) {
      for (let index = 0; index < list.length; index++) {
        await this.ShowAsync(index);
        this.printOne(list[index]);
      }
      this.ResetAfterPrinted();

      this.progressBarDialogTitle = "打印结束";
      this.proressBarDialogShow = false;
    }

    //展示打印进度
    public async ShowAsync(index) {
      return new Promise(resolve => {
        setTimeout(() => {
          this.printCount = index + 1;
          resolve("success");
        }, 300);
      });
    }

    //获取打印的模板名称
    private getTemplateName() {
      var templateName = "";
      if (this.inputModel.input_PackageType === "QY") {
        switch (this.inputModel.input_ProductType) {
          case "普通":
            templateName = "普通";
            break;
          case "圆准达":
            templateName = "圆准达";
            break;
          case "VIP":
            templateName = "VIP";
            break;
          default:
            break;
        }
      } else {
        switch (this.inputModel.input_ProductType) {
          case "普通":
            templateName = "航空";
            break;
          case "圆准达":
            templateName = "圆准达航空";
            break;
          case "VIP":
            templateName = "VIP航空";
            break;
          default:
            break;
        }
      }
      return templateName;
    }

    //打印
    private printOne(data) {
      var templateName = this.getTemplateName();
      var templatePath = "\\PrintTemplate\\" + templateName + ".frx";
      var strs = data.packageName.split("-");
      var endDate = "";
      if (dayjs(data.ExpireDateTime).isValid()) {
        var date = dayjs(data.ExpireDateTime);
        endDate = date.format("YYYY-MM-DD");
      } else {
        endDate = dayjs().format("YYYY-MM-DD");
      }
      var _data = {
        WayBillNo: data.waybillNo,
        PrintDate: dayjs().format("YYYY-MM-DD"),
        PrintTime: dayjs().format("HH:mm:ss"),
        UnpackOrgCode: data.unBagOrgCode,
        UnpackOrgName: data.unBagOrgName,
        SrcOrgCode: this.loginData.orgCode,
        PackageName: strs.length > 0 ? strs[0] : null,
        Datoubi: strs.length > 1 ? strs[1] : null,
        /* EndDate = result.ExpireDateTime*/
        EndDate: endDate,
        Info: ""
      };
      var _info = {
        mn: _data.WayBillNo,
        dtb: _data.Datoubi,
        dest: _data.UnpackOrgCode,
        src: _data.SrcOrgCode
      };
      _data.Info = JSON.stringify(_info);
      var array = [];
      array.push(_data);
      var result = obj_Printer_Core.print(
        JSON.stringify(array),
        templatePath,
        this.inputModel.input_PrinterName
      );
      if (result) {
        this.$notify.error(result)
      }
    }

    private progressBarFormCloseFunc() {
    }

    public options = [
      {
        value: "",
        label: ""
      }
    ];

    private SearchPrintDataCallback(printDatas) {
      setTimeout(() => {
        debugger;
        this.printedResultShowList = [];
        this.multipleSelection.forEach(element => {
          if (element.ID) {
            this.printedResultShowList.push({
              ID: element.ID,
              Name: element.Name,
              Type: element.Type,
              UnpackOrgName: element.UnpackOrgName,
              UnpackOrgCode: element.UnpackOrgCode,
              Count: element.Count,
              edit: false
            });
          }
        });
        var aaa = this.printedResultShowList;
        aaa.forEach(row => {
          this.$nextTick(() => {
            (this.$refs.multipleTable as Vue & {
              toggleRowSelection: Function;
            }).toggleRowSelection(row, true);
          });
        });
        for (let index = 0; index < printDatas.length; index++) {
          const element = printDatas[index];
          var result = this.FindIsExist(element);
          if (!result) {
            this.printedResultShowList.push({
              ID: element.ID,
              Name: element.Name,
              Type: element.Type,
              UnpackOrgName: element.UnpackOrgName,
              UnpackOrgCode: element.UnpackOrgCode,
              Count: "",
              edit: false
            });
          }
        }
        this.table1Loading = false;
      }, 500);
    }

    private FindIsExist(element) {
      for (let index = 0; index < this.multipleSelection.length; index++) {
        const _element = this.multipleSelection[index];
        if (_element.ID == element.ID) {
          return true;
        }
      }
      return false;
    }

    private handelSelectPrintRow(selection, row) {
      this.multipleSelection = selection;
      row.edit = !row.edit;
      this.$nextTick(() => {
        var el = document.getElementById("editinput" + row.index);
        this.selectElementContents(el);
      });
    }

    private loseFcous(row) {
      row.edit = false;
    }

    private cellClick(row) {
      row.seen = true;
    }

    private printedResultShowList = [
      // {
      //   ID: "",
      //   Name: "嘉峪关中转包-934",
      //   UnpackOrgName: "甘肃嘉峪关接驳点",
      //   Type: "汽运",
      //   edit: false,
      //   Count: "",
      //   UnpackOrgCode: ""
      // }
    ];
    public multipleSelection = [];

    public handleSelectionChange(val) {
      this.multipleSelection = val;
      // val.length == this.printedResultShowList.length ||
      if (val.length == 0) {
        for (let index = 0; index < this.printedResultShowList.length; index++) {
          this.printedResultShowList[index].edit = false;
        }
      }
    }

    private searchResultShowList = [];

    private getFormValue(element) {
      this.inputModel = element;
    }

    //获得焦点，选中文本
    private getInputFocus(event): void {
      event.currentTarget.select();
    }

    private config = config;

    public selectElementContents(el) {
      try {
        el.blur();
        el.focus();
      } catch (error) {
      }
    }

    public SearchPrintDataFunc() {
      this.countNumReadonly = false;
      this.table1Loading = true;
      setTimeout(() => {
        this.GetPackageListAsync();
      }, 500);
    }

    public GetPackageListAsync() {
      return new Promise((resolve, reject) => {
        try {
          resolve("success"); // 成功
          var input_PackageNameValue = this.inputModel.input_PackageName;
          var PackageName = "";
          if (input_PackageNameValue.includes("\n")) {
            var valueArray = input_PackageNameValue.split("\n");
            valueArray.forEach(element => {
              if (element.length > 0) {
                // PackageName += element + ";";
                PackageName += element + ",";
              }
            });
            if (PackageName.length > 0) {
              PackageName = PackageName.substr(0, PackageName.length - 1);
            }
          } else {
            PackageName = input_PackageNameValue;
          }
          var loginDataStr = obj_System_Core.getLoginData();
          this.loginData = JSON.parse(loginDataStr);
          var _request: GetNewPrintListRequest = {
            orgCode: this.loginData.orgCode,
            pageOrgCode: this.inputModel.input_UnpackOrgName,
            packageName: PackageName,
            packageType: this.inputModel.input_PackageType,
            productType: this.inputModel.input_ProductType,
            page: "",
            rows: "",
            latticeNo: "",
            firstCode: ""
          };

          var _result = getPackageList(JSON.stringify(_request));
          var _json = JSON.parse(_result);
          if (_json.data !== null) {
            var newArray = _json.data.map(function (item) {
              return {
                ID: item.key,
                Name: item.packageName,
                Type: item.packageType,
                UnpackOrgName: item.unBagOrgName,
                UnpackOrgCode: item.unBagOrgCode
              };
            });
            this.SearchPrintDataCallback(newArray);
          } else {
            this.printedResultShowList = [];
            this.table1Loading = false;
          }
        } catch (error) {
          reject("fail"); // 失败
        }
      });
    }

    private destinationorgdialogshow = false;

    public finddestinationorgcodename() {
      this.destinationorgdialogshow = true;
    }

    public UnpackOrgName = "";

    public destinationorgcodenameFunc(destinationorgModel) {
      this.destinationorgdialogshow = false;
      if (destinationorgModel != null) {
        this.UnpackOrgName = destinationorgModel.name;
        this.inputModel.input_UnpackOrgName = destinationorgModel.code;
      }
    }

    private clearlinecodename() {
    }

    private ResetFunc() {
      this.inputModel.input_PackageName = "";
      this.inputModel.input_UnpackOrgName = "";
      this.inputModel.input_PackageType = "QY";
      this.inputModel.input_ProductType = "普通";
      if (this.options.length > 0) {
        this.inputModel.input_PrinterName = this.options[0].value;
      }
    }

    private printGetHistoryDetailRequest: PrintGetHistoryDetailRequest = {
      downloadTime: "",
      expireTime: "",
      extend1: "",
      extend2: "",
      extend3: "",
      matOrgCode: "",
      packageName: "",
      packageType: "",
      printSequence: "",
      productType: "",
      takeApartOrgCode: "",
      takeApartOrgName: "",
      waybillNo: ""
    };

    private queryPrintDetails(): void {
      this.printGetHistoryDetailRequest.waybillNo = "";
      debugger;
      if (this.printDetailForm.packageName) {
        var reg = new RegExp("\n", "g");
        this.printGetHistoryDetailRequest.waybillNo = this.printDetailForm.packageName.replace(
          reg,
          ","
        );
      }
      if (!this.printDetailForm.dateRange) {
        this.$message.error("请选择打印日期");
        return;
      }
      if (this.printDetailForm.dateRange.length === 0) {
        this.$message.error("请选择打印日期");
        return;
      }
      this.printGetHistoryDetailRequest.downloadTime = this.printDetailForm.dateRange[0];
      this.printGetHistoryDetailRequest.expireTime = this.printDetailForm.dateRange[1].replace(
        "00:00:00",
        "23:59:59"
      );
      var res = getPrintGetHistoryDetail(
        JSON.stringify(this.printGetHistoryDetailRequest)
      );
      let apiRes: HttpApiResponse<PrintGetHistoryDetailResponse[]> = JSON.parse(
        res
      );
      if (apiRes.respcode !== "000") {
        this.$message.error(apiRes.respMessage);
        return;
      }

      this.searchResultShowList = apiRes.data;
      this.tabSelectIndex = "1";
      this.printDetailDialogFormVisible = false;
    }

    private printGetHistoryNumRequest: PrintGetHistoryNumRequest = {
      downloadTime: "",
      expireTime: "",
      extend1: "",
      extend2: "",
      extend3: "",
      matOrgCode: "",
      packageName: "",
      packageType: "",
      printSequence: "",
      productType: "",
      takeApartOrgCode: "",
      takeApartOrgName: "",
      waybillNo: ""
    };

    private tabTableClick(tab): void {
      if (tab.name === "1") {
        this.printDetailDialogFormVisible = true;
      }
    }

    private countNumReadonly = false;

    //查询打印数量
    private queryHistoryNum() {
      this.countNumReadonly = true;
      this.printedResultShowList = [];
      this.printGetHistoryNumRequest.downloadTime = this.printCountForm.dateRange[0];
      this.printGetHistoryNumRequest.expireTime = this.printCountForm.dateRange[1].replace(
        "00:00:00",
        "23:59:59"
      );
      this.printGetHistoryNumRequest.matOrgCode = this.loginData.orgCode;
      var res = getHistoryNum(JSON.stringify(this.printGetHistoryNumRequest));
      var apiRes: HttpApiResponse<PrintGetHistoryDetailResponse[]> = JSON.parse(
        res
      );
      if (apiRes.respcode === "000") {
        if (apiRes.data && apiRes.data.length) {
          for (let i = 0; i < apiRes.data.length; i++) {
            var e = apiRes.data[i];
            var item = {
              ID: "",
              Name: e.packageName,
              UnpackOrgName: e.takeApartOrgName,
              Type: e.packageType,
              edit: false,
              Count: 0,
              UnpackOrgCode: "",
              countNum: e.printSequence
            };
            this.printedResultShowList.push(item);
            var aaa = this.printedResultShowList;
            aaa.forEach(row => {
              this.$nextTick(() => {
                (this.$refs.multipleTable as Vue & {
                  toggleRowSelection: Function;
                }).toggleRowSelection(row, true);
              });
            });
          }
          this.printCountDialogFormVisible = false;
          this.tabSelectIndex = "0";
        } else {
          this.$message.warning("未查询到数据或历史打印记录已被清除");
        }
      }
    }
  }
